<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<button (click)="onClick()"
        class="slds-button slds-button_icon slds-button_icon-border-filled"
        i18n-title title="Help">
  <svg aria-hidden="true" class="slds-button__icon">
    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#help"></use>
  </svg>
  <span class="slds-assistive-text" i18n>Help</span>
</button>
<acc-help (closing)="onClose()"
          *ngIf="showHelp"
          [message]="message"
          [title]="title"
          [vimeoId]="vimeoId"
          [youtubeId]="youtubeId">
  <ng-content></ng-content>
</acc-help>
